import { useNavigate } from "react-router-dom";
import { componentWithCondition } from "../../../newLayout/page/components/hoc/componentWithConditionCheck";

const ManufacturingOrderAction = () => {
  const navigate = useNavigate();
  const handleCreateClick = () => {
    navigate("/manufacturing-order/create");
  };

  return (
    <>
      <li>
        <button className="tableButton activeState" onClick={handleCreateClick}>
          Create MO
        </button>
      </li>
    </>
  );
};

export const ManufacturingOrderActionWithCheck = componentWithCondition(ManufacturingOrderAction);
